import { useEffect } from "react";
import { fetchGovernanceTenant } from "../../lib/governance-api";
import { getTenantExternalId } from "../../lib/tenant-settings";
import { getAdminApiKey } from "../../lib/admin-settings";
import { getAdminJwt } from "../../lib/auth-storage";
import { applyTenantBrandingToDom } from "../../lib/branding-css";

/**
 * Loads `tenant.settings.branding` when governance credentials exist and applies dashboard theme tokens.
 */
export function TenantBranding() {
  const tid = getTenantExternalId()?.trim();
  const canGovernance = Boolean(getAdminApiKey() || getAdminJwt());

  useEffect(() => {
    const root = document.documentElement;
    if (!tid || !canGovernance) {
      applyTenantBrandingToDom(root, undefined);
      return;
    }
    let cancelled = false;
    void fetchGovernanceTenant(tid)
      .then((t) => {
        if (cancelled) return;
        applyTenantBrandingToDom(root, t.settings ?? {});
      })
      .catch(() => {
        if (cancelled) return;
        applyTenantBrandingToDom(root, undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [tid, canGovernance]);

  return null;
}
